import { prefix } from '../api.config'

export const name = 'invoice-api-config'
export const api = {
  buyer: {
    save: `${prefix}/app/wx/mini/invoice/buyer/save` // post
  },
  seller: {
    getInvoiceDetails: `${prefix}/app/wx/mini/invoice/seller/getInvoiceDetails/:id` // get /:id
  }
}
